var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoxplotLowQuartile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72931 0.4375H5.77069C6.0535 0.4375 6.28103 0.665865 6.28103 0.949719L6.28103 5.21822H8.48826C8.94332 5.21822 9.17084 5.76885 8.84975 6.09326L5.11149 9.84954C4.91161 10.0502 4.58839 10.0502 4.38851 9.84954L0.650247 6.09326C0.329156 5.77099 0.556684 5.21822 1.01174 5.21822H3.21897V0.949719C3.21897 0.665865 3.4465 0.4375 3.72931 0.4375Z",
    fill: "#1E88E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxplotLowQuartile);
export default __webpack_public_path__ + "static/media/icon_boxplot_low-quartile.c22f0c93896e872a182cf4f85773fa03.svg";
export { ForwardRef as ReactComponent };